import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import RatingBadge from "@/components/base/RatingBadge";

interface MovieCardProps {
  movie: Movie;
  highlight?: string;
}

function highlightText(text: string, keyword?: string) {
  if (!keyword) return text;
  const lower = text.toLowerCase();
  const key = keyword.toLowerCase();
  const index = lower.indexOf(key);
  if (index === -1) return text;
  return (
    <>
      {text.slice(0, index)}
      <mark className="bg-accent-200 px-0.5 text-accent-900">
        {text.slice(index, index + keyword.length)}
      </mark>
      {text.slice(index + keyword.length)}
    </>
  );
}

export default function MovieCard({ movie, highlight }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 国产影视作品`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute left-2 top-2">
          <RatingBadge rating={movie.rating} />
        </div>
        <span className="absolute right-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50">
          {movie.type}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="line-clamp-1 font-heading text-sm font-bold text-foreground-950 md:text-base">
          {highlightText(movie.title, highlight)}
        </h3>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="text-background-400">·</span>
          <span>{movie.region}</span>
          <span className="text-background-400">·</span>
          <span className="line-clamp-1">{movie.genres.join(" / ")}</span>
        </div>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {movie.synopsis}
        </p>
      </div>
    </Link>
  );
}